import { Box, Card, Grid, styled, TextField } from '@mui/material';
import dayjs from 'dayjs';

import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import React from 'react';
import { H4 } from 'app/components/Typography';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useEffect } from 'react';
import { getUserInvoiceOrder } from 'app/contexts/reducers/transaction/oderSlice';
import { getSpecificInvoice } from 'app/contexts/reducers/transaction/invoiceSlice';
import { useParams } from 'react-router-dom';
import CustomerInvoiceOrder from './Shared/CustomerInvoiceOrder';

const StyledCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '24px !important',
  background: theme.palette.background.paper,
  [theme.breakpoints.down('sm')]: { padding: '16px !important' }
}));

const ContentBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'flex-start',
  '& small': { color: theme.palette.text.secondary },
  '& .icon': { opacity: 0.6, fontSize: '44px', color: theme.palette.primary.main }
}));

const SingleInvoice = ({ handleApiCall, apiCall }) => {
  const dispatch = useDispatch();
  const { invoiceId } = useParams();

  const { isuserInvoiceOrderSuccess, userInvoiceOrder } = useSelector((state) => state.order);
  const { isSpecificInvoiceSuccess, specificInvoiceData } = useSelector((state) => state.invoice);
  const intialInvoiceData = {
    bookNumber: '',
    customerName: '',
    customerId: null,
    usedWeight: '',
    selfWeight: '',
    usedPcs: '',
    labourChargePerPcs: '',
    labourCharge: '',
    purity: '',
    diamondCaratPrice: '',
    diamondPrice: '',
    productPrice: '',
    extraCost: 0,
    mobileNumber: '',
    address: '',
    email: '',
    date: dayjs(),
    remark: '',
    quantity: '',
    subTotal: '',
    total: '',
    gstNumber: '',
    panNumber: '',
    state: '',
    roundOff: 0,
    orderType: 0,
    invoiceNumber: '',
    sgstPercentage: 0,
    sgstValue: 0,
    cgstPercentage: 0,
    cgstValue: 0,
    igstPercentage: 0,
    igstValue: 0,
    dcgstPercentage: 0,
    dcgstValue: 0,
    dsgstPercentage: 0,
    dsgstValue: 0,
    lcgstPercentage: 0,
    lcgstValue: 0,
    lsgstPercentage: 0,
    lsgstValue: 0,
    digstPercentage: 0,
    digstValue: 0,
    ligstPercentage: 0,
    ligstValue: 0,
    orders: []
  };

  const [invoiceDetails, setInvoiceDetails] = useState(intialInvoiceData);

  const [specificInvoiceOrderData, setSpecificInvoiceOrderData] = useState([]);
  const [userInvoiceOrders, setUserInvoiceOrdrs] = useState([]);

  const [selectedOrderDetails, setSelectedOrderDetails] = useState([]);

  useEffect(() => {
    dispatch(getSpecificInvoice({ invoiceId }));
    dispatch(getUserInvoiceOrder({ invoiceId }));
  }, [dispatch, invoiceId]);
  // -----------------Set Details For Invoice ----------------
  useEffect(() => {
    if (specificInvoiceData) {
      for (const invoiceDetails of specificInvoiceOrderData) {
        setInvoiceDetails({
          bookNumber: invoiceDetails.book_number,
          invoiceNumber: invoiceDetails.invoice_number,
          customerName: invoiceDetails.customer_name,
          customerId: invoiceDetails.customer_id,
          usedWeight: invoiceDetails.studd_weight,
          selfWeight: invoiceDetails.self_weight,
          usedPcs: invoiceDetails.studd_pieces,
          labourChargePerPcs: invoiceDetails.labour_charge_per_pcs,
          labourCharge: invoiceDetails.labour_charge,
          purity: invoiceDetails.purity,
          diamondCaratPrice: invoiceDetails.diamond_carat_price,
          diamondPrice: invoiceDetails.diamond_price,
          productPrice: invoiceDetails.product_price,
          extraCost: invoiceDetails.extra_cost,
          mobileNumber: invoiceDetails.mobile_number,
          address: invoiceDetails.address,
          email: invoiceDetails.email,
          date: dayjs(invoiceDetails.date),
          remark: invoiceDetails.remark,
          quantity: invoiceDetails.quantity,
          subTotal: invoiceDetails.sub_total,
          total: invoiceDetails.total,
          gstNumber: invoiceDetails.gst_number,
          panNumber: invoiceDetails.pan_number,
          state: invoiceDetails.state,
          roundOff: invoiceDetails.round_off,
          orderType: invoiceDetails.order_type,
          sgstPercentage: invoiceDetails.sgst_percentage,
          sgstValue: invoiceDetails.sgst_value,
          cgstPercentage: invoiceDetails.cgst_percentage,
          cgstValue: invoiceDetails.cgst_value,
          igstPercentage: invoiceDetails.igst_percentage,
          igstValue: invoiceDetails.igst_value,
          dcgstPercentage: invoiceDetails.dcgst_percentage,
          dcgstValue: invoiceDetails.dcgst_value,
          dsgstPercentage: invoiceDetails.dsgst_percentage,
          dsgstValue: invoiceDetails.dsgst_value,
          lcgstPercentage: invoiceDetails.lcgst_percentage,
          lcgstValue: invoiceDetails.lcgst_value,
          lsgstPercentage: invoiceDetails.lsgst_percentage,
          lsgstValue: invoiceDetails.lsgst_value,
          digstPercentage: invoiceDetails.digst_percentage,
          digstValue: invoiceDetails.digst_value,
          ligstPercentage: invoiceDetails.ligst_percentage,
          ligstValue: invoiceDetails.ligst_value,
          orders: []
        });
      }
    }
  }, [invoiceId, specificInvoiceData, specificInvoiceOrderData, isSpecificInvoiceSuccess]);
  useEffect(() => {
    if (isuserInvoiceOrderSuccess) {
      setUserInvoiceOrdrs(userInvoiceOrder.data.data);
    }
  }, [userInvoiceOrder, isuserInvoiceOrderSuccess]);
  useEffect(() => {
    if (isSpecificInvoiceSuccess) {
      setSpecificInvoiceOrderData(specificInvoiceData.data.data);
    }
  }, [specificInvoiceData, isSpecificInvoiceSuccess]);
  return (
    <React.Fragment>
      {' '}
      <Grid container spacing={3} sx={{ mb: '24px' }}>
        <Grid item xs={12} md={12}>
          <StyledCard elevation={6}>
            <H4 sx={{ mb: 2 }}>CREATE INVOICE</H4>
            <Grid container sx={{ marginBottom: 3 }}>
              <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                <ContentBox>
                  <TextField
                    id='customerName'
                    type='text'
                    margin='dense'
                    size='small'
                    label='Customer Name'
                    required
                    InputLabelProps={{ shrink: true }}
                    sx={{ my: 1, width: '80%' }}
                    variant='standard'
                    value={invoiceDetails.customerName}
                  />
                </ContentBox>
                <ContentBox>
                  <TextField
                    id='usedPcs'
                    type='text'
                    margin='dense'
                    size='small'
                    label='Used Piece'
                    required
                    InputLabelProps={{ shrink: true }}
                    sx={{ my: 1, width: '80%' }}
                    variant='standard'
                    value={invoiceDetails.usedPcs}
                  />
                </ContentBox>
                <ContentBox>
                  <TextField
                    id='labourpiececharge'
                    type='number'
                    margin='dense'
                    size='small'
                    label='Labour/Piece Charge'
                    InputLabelProps={{ shrink: true }}
                    sx={{ my: 1, width: '80%' }}
                    variant='standard'
                    value={invoiceDetails.labourChargePerPcs}
                  />
                </ContentBox>
              </Grid>
              <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                <ContentBox>
                  <TextField
                    id='customerId'
                    required
                    type='text'
                    margin='dense'
                    size='small'
                    label='Customer Id'
                    InputLabelProps={{ shrink: true }}
                    sx={{ my: 1, width: '80%' }}
                    variant='standard'
                    value={invoiceDetails.customerId}
                  />
                </ContentBox>

                <ContentBox>
                  <TextField
                    id='usedWeight'
                    required
                    type='text'
                    margin='dense'
                    size='small'
                    label='Used Weight'
                    InputLabelProps={{ shrink: true }}
                    sx={{ my: 1, width: '80%' }}
                    variant='standard'
                    value={invoiceDetails.usedWeight}
                  />
                </ContentBox>

                <ContentBox>
                  <TextField
                    id='labourcharge'
                    required
                    type='text'
                    margin='dense'
                    size='small'
                    label='Labour Charge'
                    InputLabelProps={{ shrink: true }}
                    sx={{ my: 1, width: '80%' }}
                    variant='standard'
                    value={invoiceDetails.labourCharge}
                  />
                </ContentBox>
              </Grid>
              <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    sx={{ width: '80%', my: 1 }}
                    label='Date'
                    disabled
                    format='DD/MM/YYYY'
                    value={invoiceDetails.date}
                    slotProps={{ textField: { variant: 'standard' } }}
                  />
                </LocalizationProvider>
                <ContentBox>
                  <TextField
                    id='selfUsedWeight'
                    type='number'
                    margin='dense'
                    size='small'
                    label='Self Used Weight'
                    InputLabelProps={{ shrink: true }}
                    sx={{ my: 1, width: '80%' }}
                    variant='standard'
                    value={invoiceDetails.selfWeight}
                  />
                </ContentBox>
                <ContentBox>
                  <TextField
                    id='diamondcaratprice'
                    type='number'
                    margin='dense'
                    size='small'
                    label='Diamond/Carat Price'
                    disabled={Number(invoiceDetails.selfWeight) === 0 ? true : false}
                    InputLabelProps={{ shrink: true }}
                    sx={{ my: 1, width: '80%' }}
                    variant='standard'
                    value={invoiceDetails.diamondCaratPrice}
                  />
                </ContentBox>
              </Grid>
              <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                <ContentBox>
                  <TextField
                    id='invoiceNumber'
                    type='text'
                    margin='dense'
                    size='small'
                    label='Bill Number'
                    disabled
                    InputLabelProps={{ shrink: true }}
                    sx={{ my: 1, width: '80%' }}
                    variant='standard'
                    value={invoiceDetails.invoiceNumber}
                  />
                </ContentBox>
                <ContentBox>
                  <TextField
                    id='bookNumber'
                    type='text'
                    margin='dense'
                    size='small'
                    label='Book Number'
                    required
                    disabled
                    InputLabelProps={{ shrink: true }}
                    sx={{ my: 1, width: '80%' }}
                    variant='standard'
                    value={invoiceDetails.bookNumber}
                  />
                </ContentBox>
                <ContentBox>
                  <TextField
                    id='productPrice'
                    type='number'
                    margin='dense'
                    size='small'
                    label='Product Price'
                    InputLabelProps={{ shrink: true }}
                    sx={{ my: 1, width: '80%' }}
                    variant='standard'
                    value={invoiceDetails.productPrice}
                  />
                </ContentBox>
                <ContentBox>
                  <TextField
                    id='diamondPrice'
                    type='text'
                    margin='dense'
                    size='small'
                    label='Diamond Price'
                    InputLabelProps={{ shrink: true }}
                    sx={{ my: 1, width: '80%' }}
                    variant='standard'
                    value={invoiceDetails.diamondPrice}
                  />
                </ContentBox>
              </Grid>
              <Grid container>
                <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                  <ContentBox>
                    <TextField
                      id='purity'
                      type='text'
                      margin='dense'
                      size='small'
                      label='Purity'
                      InputLabelProps={{ shrink: true }}
                      sx={{ my: 1, width: '80%' }}
                      variant='standard'
                      value={invoiceDetails.purity}
                    />
                  </ContentBox>
                  <ContentBox>
                    <TextField
                      multiline
                      maxRows={4}
                      id='specialNote'
                      type='text'
                      margin='dense'
                      size='small'
                      label='Special Note'
                      InputLabelProps={{ shrink: true }}
                      sx={{ my: 1, width: '80%' }}
                      variant='standard'
                      value={invoiceDetails.remark}
                    />
                  </ContentBox>

                  <ContentBox>
                    {typeof invoiceDetails.orderType === 'string' &&
                      typeof invoiceDetails.state === 'string' &&
                      invoiceDetails.orderType.toLowerCase() === 'job-work' &&
                      invoiceDetails.state.toLowerCase() === 'gujarat' && (
                        <TextField
                          id='cgstPercentage'
                          type='number'
                          margin='dense'
                          size='small'
                          label='CGST %'
                          InputLabelProps={{ shrink: true }}
                          sx={{ my: 1, width: '80%' }}
                          variant='standard'
                          value={invoiceDetails.cgstPercentage}
                        />
                      )}
                    {typeof invoiceDetails.orderType === 'string' &&
                      typeof invoiceDetails.state === 'string' &&
                      invoiceDetails.orderType.toLowerCase() === 'self' &&
                      invoiceDetails.state.toLowerCase() === 'gujarat' && (
                        <TextField
                          id='dcgstPercentage'
                          type='number'
                          margin='dense'
                          size='small'
                          label='D-CGST %'
                          InputLabelProps={{ shrink: true }}
                          sx={{ my: 1, width: '80%' }}
                          variant='standard'
                          value={invoiceDetails.dcgstPercentage}
                        />
                      )}
                    {typeof invoiceDetails.orderType === 'string' &&
                      typeof invoiceDetails.state === 'string' &&
                      invoiceDetails.orderType.toLowerCase() === 'job-work' &&
                      invoiceDetails.state.toLowerCase() !== 'gujarat' && (
                        <TextField
                          id='igstPercentage'
                          type='number'
                          margin='dense'
                          size='small'
                          label='IGST %'
                          InputLabelProps={{ shrink: true }}
                          sx={{ my: 1, width: '80%' }}
                          variant='standard'
                          value={invoiceDetails.igstPercentage}
                        />
                      )}
                    {typeof invoiceDetails.orderType === 'string' &&
                      typeof invoiceDetails.state === 'string' &&
                      invoiceDetails.orderType.toLowerCase() === 'self' &&
                      invoiceDetails.state.toLowerCase() !== 'gujarat' && (
                        <TextField
                          id='digstPercentage'
                          type='number'
                          margin='dense'
                          size='small'
                          label='D-IGST %'
                          InputLabelProps={{ shrink: true }}
                          sx={{ my: 1, width: '80%' }}
                          variant='standard'
                          value={invoiceDetails.digstPercentage}
                        />
                      )}
                  </ContentBox>
                  <ContentBox>
                    {typeof invoiceDetails.orderType === 'string' &&
                      typeof invoiceDetails.state === 'string' &&
                      invoiceDetails.orderType.toLowerCase() === 'job-work' &&
                      invoiceDetails.state.toLowerCase() === 'gujarat' && (
                        <TextField
                          id='cgstValue'
                          type='number'
                          margin='dense'
                          size='small'
                          label='CGST Value'
                          InputLabelProps={{ shrink: true }}
                          sx={{ my: 1, width: '80%' }}
                          variant='standard'
                          value={invoiceDetails.cgstValue}
                        />
                      )}
                    {typeof invoiceDetails.orderType === 'string' &&
                      typeof invoiceDetails.state === 'string' &&
                      invoiceDetails.orderType.toLowerCase() === 'self' &&
                      invoiceDetails.state.toLowerCase() === 'gujarat' && (
                        <TextField
                          id='dcgstValue'
                          type='number'
                          margin='dense'
                          size='small'
                          label='D-CGST Value'
                          InputLabelProps={{ shrink: true }}
                          sx={{ my: 1, width: '80%' }}
                          variant='standard'
                          value={invoiceDetails.dcgstValue}
                        />
                      )}
                    {typeof invoiceDetails.orderType === 'string' &&
                      typeof invoiceDetails.state === 'string' &&
                      invoiceDetails.orderType.toLowerCase() === 'job-work' &&
                      invoiceDetails.state.toLowerCase() !== 'gujarat' && (
                        <TextField
                          id='igstValue'
                          type='number'
                          margin='dense'
                          size='small'
                          label='IGST Value'
                          InputLabelProps={{ shrink: true }}
                          sx={{ my: 1, width: '80%' }}
                          variant='standard'
                          value={invoiceDetails.igstValue}
                        />
                      )}
                    {typeof invoiceDetails.orderType === 'string' &&
                      typeof invoiceDetails.state === 'string' &&
                      invoiceDetails.orderType.toLowerCase() === 'self' &&
                      invoiceDetails.state.toLowerCase() !== 'gujarat' && (
                        <TextField
                          id='digstValue'
                          type='number'
                          margin='dense'
                          size='small'
                          label='D-IGST value'
                          InputLabelProps={{ shrink: true }}
                          sx={{ my: 1, width: '80%' }}
                          variant='standard'
                          value={invoiceDetails.digstValue}
                        />
                      )}
                  </ContentBox>
                </Grid>
                <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                  <ContentBox>
                    <TextField
                      id='panNumber'
                      type='text'
                      margin='dense'
                      size='small'
                      label='Pan-Number'
                      InputLabelProps={{ shrink: true }}
                      sx={{ my: 1, width: '80%' }}
                      variant='standard'
                      value={invoiceDetails.panNumber}
                    />
                  </ContentBox>
                  <ContentBox>
                    <TextField
                      id='orderType'
                      type='text'
                      margin='dense'
                      size='small'
                      label='Order Type'
                      InputLabelProps={{ shrink: true }}
                      sx={{ my: 1, width: '80%' }}
                      variant='standard'
                      value={invoiceDetails.orderType == null ? '-' : invoiceDetails.orderType}
                    />
                  </ContentBox>
                  <ContentBox>
                    {typeof invoiceDetails.orderType === 'string' &&
                      typeof invoiceDetails.state === 'string' &&
                      invoiceDetails.orderType.toLowerCase() === 'job-work' &&
                      invoiceDetails.state.toLowerCase() === 'gujarat' && (
                        <TextField
                          id='sgstPercentage'
                          type='number'
                          margin='dense'
                          size='small'
                          label='SGST %'
                          InputLabelProps={{ shrink: true }}
                          sx={{ my: 1, width: '80%' }}
                          variant='standard'
                          value={invoiceDetails.sgstPercentage}
                        />
                      )}
                    {typeof invoiceDetails.orderType === 'string' &&
                      typeof invoiceDetails.state === 'string' &&
                      invoiceDetails.orderType.toLowerCase() === 'self' &&
                      invoiceDetails.state.toLowerCase() === 'gujarat' && (
                        <TextField
                          id='dsgstPercentage'
                          type='number'
                          margin='dense'
                          size='small'
                          label='D-SGST %'
                          InputLabelProps={{ shrink: true }}
                          sx={{ my: 1, width: '80%' }}
                          variant='standard'
                          value={invoiceDetails.dsgstPercentage}
                        />
                      )}
                    {typeof invoiceDetails.orderType === 'string' &&
                      typeof invoiceDetails.state === 'string' &&
                      invoiceDetails.orderType.toLowerCase() === 'self' &&
                      invoiceDetails.state.toLowerCase() !== 'gujarat' && (
                        <TextField
                          id='ligstPercentage'
                          type='number'
                          margin='dense'
                          size='small'
                          label='L-IGST %'
                          InputLabelProps={{ shrink: true }}
                          sx={{ my: 1, width: '80%' }}
                          variant='standard'
                          value={invoiceDetails.ligstPercentage}
                        />
                      )}
                  </ContentBox>
                  <ContentBox>
                    {typeof invoiceDetails.orderType === 'string' &&
                      typeof invoiceDetails.state === 'string' &&
                      invoiceDetails.orderType.toLowerCase() === 'job-work' &&
                      invoiceDetails.state.toLowerCase() === 'gujarat' && (
                        <TextField
                          id='sgstValue'
                          type='number'
                          margin='dense'
                          size='small'
                          label='SGST Value'
                          InputLabelProps={{ shrink: true }}
                          sx={{ my: 1, width: '80%' }}
                          variant='standard'
                          value={invoiceDetails.sgstValue}
                        />
                      )}
                    {typeof invoiceDetails.orderType === 'string' &&
                      typeof invoiceDetails.state === 'string' &&
                      invoiceDetails.orderType.toLowerCase() === 'self' &&
                      invoiceDetails.state.toLowerCase() === 'gujarat' && (
                        <TextField
                          id='dsgstValue'
                          type='number'
                          margin='dense'
                          size='small'
                          label='D-SGST Value'
                          InputLabelProps={{ shrink: true }}
                          sx={{ my: 1, width: '80%' }}
                          variant='standard'
                          value={invoiceDetails.dsgstValue}
                        />
                      )}
                    {typeof invoiceDetails.orderType === 'string' &&
                      typeof invoiceDetails.state === 'string' &&
                      invoiceDetails.orderType.toLowerCase() === 'self' &&
                      invoiceDetails.state.toLowerCase() !== 'gujarat' && (
                        <TextField
                          id='ligstValue'
                          type='number'
                          margin='dense'
                          size='small'
                          label='L-IGST value'
                          InputLabelProps={{ shrink: true }}
                          sx={{ my: 1, width: '80%' }}
                          variant='standard'
                          value={invoiceDetails.ligstValue}
                        />
                      )}
                  </ContentBox>
                </Grid>
                <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                  <ContentBox>
                    <TextField
                      id='mobileNumber'
                      type='tel'
                      margin='dense'
                      size='small'
                      label='Mobile Number'
                      InputLabelProps={{ shrink: true }}
                      sx={{ my: 1, width: '80%' }}
                      variant='standard'
                      value={invoiceDetails.mobileNumber == null ? '' : invoiceDetails.mobileNumber}
                    />
                  </ContentBox>
                  <ContentBox>
                    <TextField
                      id='state'
                      type='text'
                      margin='dense'
                      size='small'
                      label='State'
                      InputLabelProps={{ shrink: true }}
                      sx={{ my: 1, width: '80%' }}
                      variant='standard'
                      value={invoiceDetails.state}
                    />
                  </ContentBox>
                  <ContentBox>
                    {typeof invoiceDetails.orderType === 'string' &&
                      typeof invoiceDetails.state === 'string' &&
                      invoiceDetails.orderType.toLowerCase() === 'self' &&
                      invoiceDetails.state.toLowerCase() === 'gujarat' && (
                        <TextField
                          id='lcgstPercentage'
                          type='number'
                          margin='dense'
                          size='small'
                          label='L-CGST %'
                          InputLabelProps={{ shrink: true }}
                          sx={{ my: 1, width: '80%' }}
                          variant='standard'
                          value={invoiceDetails.lcgstPercentage}
                        />
                      )}
                  </ContentBox>
                  <ContentBox>
                    {typeof invoiceDetails.orderType === 'string' &&
                      typeof invoiceDetails.state === 'string' &&
                      invoiceDetails.orderType.toLowerCase() === 'self' &&
                      invoiceDetails.state.toLowerCase() === 'gujarat' && (
                        <TextField
                          id='lcgstValue'
                          type='number'
                          margin='dense'
                          size='small'
                          label='L-CGST Value'
                          InputLabelProps={{ shrink: true }}
                          sx={{ my: 1, width: '80%' }}
                          variant='standard'
                          value={invoiceDetails.lcgstValue}
                        />
                      )}
                  </ContentBox>
                </Grid>
                <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                  <ContentBox>
                    <TextField
                      id='extraCost'
                      type='text'
                      margin='dense'
                      size='small'
                      label='Extra Cost'
                      InputLabelProps={{ shrink: true }}
                      sx={{ my: 1, width: '80%' }}
                      variant='standard'
                      value={invoiceDetails.extraCost}
                    />
                  </ContentBox>

                  <ContentBox>
                    <TextField
                      id='gstNumber'
                      type='text'
                      margin='dense'
                      size='small'
                      label='Gst Number'
                      InputLabelProps={{ shrink: true }}
                      sx={{ my: 1, width: '80%' }}
                      variant='standard'
                      value={invoiceDetails.gstNumber}
                    />
                  </ContentBox>
                  <ContentBox>
                    {typeof invoiceDetails.orderType === 'string' &&
                      typeof invoiceDetails.state === 'string' &&
                      invoiceDetails.orderType.toLowerCase() === 'self' &&
                      invoiceDetails.state.toLowerCase() === 'gujarat' && (
                        <TextField
                          id='lsgstPercentage'
                          type='number'
                          margin='dense'
                          size='small'
                          label='L-SGST %'
                          InputLabelProps={{ shrink: true }}
                          sx={{ my: 1, width: '80%' }}
                          variant='standard'
                          value={invoiceDetails.lsgstPercentage}
                        />
                      )}
                  </ContentBox>
                  <ContentBox>
                    {typeof invoiceDetails.orderType === 'string' &&
                      typeof invoiceDetails.state === 'string' &&
                      invoiceDetails.orderType.toLowerCase() === 'self' &&
                      invoiceDetails.state.toLowerCase() === 'gujarat' && (
                        <TextField
                          id='lsgstValue'
                          type='number'
                          margin='dense'
                          size='small'
                          label='L-SGST Value'
                          InputLabelProps={{ shrink: true }}
                          sx={{ my: 1, width: '80%' }}
                          variant='standard'
                          value={invoiceDetails.lsgstValue}
                        />
                      )}
                  </ContentBox>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                  <ContentBox>
                    <TextField
                      id='quantity'
                      type='text'
                      margin='dense'
                      size='small'
                      label='Quantity'
                      InputLabelProps={{ shrink: true }}
                      sx={{ my: 1, width: '80%' }}
                      variant='outlined'
                      value={invoiceDetails.quantity}
                    />
                  </ContentBox>
                </Grid>
                <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                  <ContentBox>
                    <TextField
                      id='subtotal'
                      type='text'
                      margin='dense'
                      size='small'
                      label='Sub Total'
                      InputLabelProps={{ shrink: true }}
                      sx={{ my: 1, width: '80%' }}
                      variant='outlined'
                      value={invoiceDetails.subTotal}
                    />
                  </ContentBox>
                </Grid>
                <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                  <ContentBox>
                    <TextField
                      id='tota;'
                      type='text'
                      margin='dense'
                      size='small'
                      label='Total'
                      InputLabelProps={{ shrink: true }}
                      sx={{ my: 1, width: '80%' }}
                      variant='outlined'
                      value={invoiceDetails.total}
                    />
                  </ContentBox>
                </Grid>
              </Grid>
            </Grid>
            {userInvoiceOrders.length > 0 && (
              <CustomerInvoiceOrder
                invoiceId={invoiceId}
                userInvoiceOrders={userInvoiceOrders}
                selectedOrderDetails={selectedOrderDetails}
                setSelectedOrderDetails={setSelectedOrderDetails}
              />
            )}
          </StyledCard>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default SingleInvoice;
